import { Component } from '@angular/core';
import { BaseModalOverlayComponent } from '../base-modal-overlay/base-modal-overlay.component';

@Component({
  selector: 'app-confirm-overlay',
  templateUrl: './confirm-overlay.component.html',
  styleUrls: ['./confirm-overlay.component.scss']
})
export class ConfirmOverlayComponent extends BaseModalOverlayComponent {}
